import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core';
import React, {useContext, useState} from 'react';
import OrderSettingsPageStoreContext from '../context';
import {observer} from 'mobx-react';
import { SketchPicker } from 'react-color';
import {Button} from '../../../../../common/components/libs';

interface Props {
    current: string | null
    field: 'buttonsBackgroundColor' | 'categoriesBackgroundColor'
}
const ChooseColorForm = (props: Props) => {
    const store = useContext(OrderSettingsPageStoreContext);
    const open = store.forms.chooseColorFormOpen;
    const [currentColor, setCurrentColor] = useState(props.current)

    return (
        <Dialog
            open={open}
            onClose={() => {
                store.closeChooseColorForm()
            }}
        >
            <DialogTitle>
                Выбор цвета
            </DialogTitle>
            <DialogContent>
                <SketchPicker color={currentColor}
                              onChange={(color) => {setCurrentColor(color.hex)}}
                              disableAlpha={true}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    store.closeChooseColorForm()
                }} color="primary">
                    Отменить
                </Button>
                <Button
                    color="primary"
                    onClick={() => {
                        switch (props.field) {
                            case "buttonsBackgroundColor":
                                store.setButtonsColor(currentColor)
                                break
                            case "categoriesBackgroundColor":
                                store.setCategoriesColor(currentColor)
                                break
                        }
                        store.closeChooseColorForm()
                    }}
                    variant={'contained'}
                >
                    Выбрать
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default observer(ChooseColorForm)